import React from 'react'
import IconBase from 'components/atoms/IconBase/IconBase'

interface Props {
  idVariant?: string
  className?: string
}

function Add({ idVariant = '', className }: Props) {
  return (
    <IconBase name="add" w={24} className={className}>
      <path fillRule="evenodd" clipRule="evenodd" d="M11.5 11.5V5H12.5V11.5H19V12.5H12.5V19H11.5V12.5H5V11.5H11.5Z" fill="currentColor"/>
    </IconBase>
  )
}

export default Add
